import { jsx as o } from "react/jsx-runtime";
import d from "../Card/index.js";
import f from "../Link/index.js";
import { useTheme as h } from "../ThemeProvider/index.js";
import { c as _ } from "../index-rKuIKazb.js";
import '../assets/index13.css';const k = "_layout_4hoju_2", p = "_dark_4hoju_14", t = {
  layout: k,
  dark: p
}, x = (r) => {
  const { children: s, className: a, CustomLink: e, href: m, to: c, target: n, rel: l } = r, i = h(), u = _(t[i], t.layout, a);
  return /* @__PURE__ */ o(f, { CustomLink: e, href: m, to: c, target: n, rel: l, children: /* @__PURE__ */ o(d, { className: u, children: s }) });
};
export {
  x as default
};
